import React, { FC } from 'react'

import { Txt, Tooltip } from 'src/components/atoms'

type Props = {
  children: React.ReactElement<any, any>
}

export const AddExternalUserTooltip: FC<Props> = ({ children }) => {
  return (
    <Tooltip
      placement="top"
      content={
        <Txt sizeType="s">
          指定メールアドレスへROOV compassへ社外ユーザーとしてロ
          <br />
          グインできるパスワードが記載されたメールが送信されます。
          <br />
          <b>社外ユーザーはこのサービスへのアクセスできません。</b>
          <br />
          <br />
          社外ユーザーを特定のROOV compassへログインさせるために
          <br />は
          <span className="tw-text-errorRed-default">
            <b>プロジェクト詳細の「アサイン」から追加する必要があります。</b>
          </span>
        </Txt>
      }
    >
      {children}
    </Tooltip>
  )
}
